import { useNavigate } from "react-router-dom";

export default function ReturnButton() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate("/dashboard")}
      className="absolute top-6 right-8 bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded shadow font-bold"
    >
      Retour
    </button>
  );
}
